export default "__VITE_ASSET__8a910a85__"